// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Item-ItemDetail-ItemForm-WarningLabel-__WarningLabel___2PTp5","circle":"app-pages-Library-Item-ItemDetail-ItemForm-WarningLabel-__WarningLabel___1Fp7B","lock":"app-pages-Library-Item-ItemDetail-ItemForm-WarningLabel-__WarningLabel___OdQFI","content":"app-pages-Library-Item-ItemDetail-ItemForm-WarningLabel-__WarningLabel___2PKdd"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Item/ItemDetail/ItemForm/WarningLabel/WarningLabel.css
// module id = 2181
// module chunks = 0